export class SaVarianceRange {
    constructor(json: any) {
        if (json) {
            Object.assign(this, json);
        }
    }

    range1Boundary: number;
    range2Boundary: number;
}
